import React, { useState } from 'react';
import * as nav from "../components/Navbar"

const Navbar = ({ isAuthenticated, handleLogout, loggingOut }) => (
    <section>
        {/* Desktop Navbar */}
        <nav.DesktopNav
            isAuthenticated={isAuthenticated}
            handleLogout={handleLogout}
            loggingOut={loggingOut}
        />
        {/* Mobile Navbar */}
        <nav.MobileNav
            handleLogout={handleLogout}
            loggingOut={loggingOut}
        />
    </section>
);

export default Navbar;
